import { CommonModule, DatePipe } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatIconModule } from '@angular/material/icon'
import { RouterModule } from '@angular/router'
import { MaterialModule } from '../material.module'
import { ActionsPopupComponent } from './components/actions-popup/actions-popup.component'
import { AddressComponent } from './components/address/address.component'
import { ButtonComponent } from './components/button/button.component'
import { CallbackComponent } from './components/callback/callback.component'
import { CheckboxComponent } from './components/checkbox/checkbox.component'
import { DialogComponent } from './components/dialog/dialog.component'
import { DropdownComponent } from './components/dropdown/dropdown.component'
import { ErrorPageComponent } from './components/error-page/error-page.component'
import { ErrorComponent } from './components/error/error.component'
import { HistoryComponent } from './components/history/history.component'
import { IconLinkComponent } from './components/icon-link/icon-link.component'
import { IconComponent } from './components/icon/icon.component'
import { ImageComponent } from './components/image/image.component'
import { InitialsComponent } from './components/initials/initials.component'
import { BaseLoadingComponent, LoadingComponent } from './components/loading/loading.component'
import { PaginationComponent } from './components/pagination/pagination.component'
import { ProgressIndicatorComponent } from './components/progress-indicator/progress-indicator.component'
import { SearchComponent } from './components/search/search.component'
import { SearchDropDownComponent } from './components/searchdropdown/search-dropdown.component'
import { SidebarComponent } from './components/sidebar/sidebar.component'
import { SortIndicatorComponent } from './components/sort-indicator/sort-indicator.component'
import { ToastComponent } from './components/toast/toast.component'
import { TooltipComponent } from './components/tooltip/tooltip.component'
import { ActionResultDialogComponent } from './dialogs/action-result-dialog/action-result-dialog.component'
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component'
import { OrganizationDialogComponent } from './dialogs/organization-dialog/organization-dialog.component'
import { DialogDirective } from './directives/dialog.directive'
import { PhoneDirective } from './directives/phone.directive'
import { ToasterDirective } from './directives/toaster.directive'
import './extensions/string.extensions'
import { GenericConfirmationModalComponent } from './modals/generic-confirmation-modal/generic-confirmation-modal.component'
import { GenericModalComponent } from './modals/generic-modal/generic-modal.component'
import { GenericSuccessModelComponent } from './modals/generic-success-modal/generic-success-modal.component'
import { SupportModalComponent } from './modals/support-modal/support-modal.component'
import { SupportTicketRequestModalComponent } from './modals/support-ticket-request-modal/support-ticket-request-modal.component'
import { UserProfileModalComponent } from './modals/user-profile-modal/user-profile-modal.component'
import { ArrayFilterPipe } from './pipes/filter-by.pipe'
import { LimitToPipe } from './pipes/limit-to.pipe'
import { FormattedTablePipe } from './pipes/table.pipe'
import { DialogService } from './services/dialog.service'
import { AlertService } from './services/alert.service'
import { provideUiTour, TourAnchorMatMenuDirective, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu'
@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MaterialModule,
    TourAnchorMatMenuDirective,
    TourStepTemplateComponent,
  ],
  declarations: [
    // --- UI Components ---
    ActionsPopupComponent,
    AddressComponent,
    BaseLoadingComponent,
    ButtonComponent,
    CallbackComponent,
    CheckboxComponent,
    DialogComponent,
    DropdownComponent,
    ErrorComponent,
    ErrorPageComponent,
    HistoryComponent,
    IconComponent,
    IconLinkComponent,
    ImageComponent,
    InitialsComponent,
    LoadingComponent,
    PaginationComponent,
    ProgressIndicatorComponent,
    SearchComponent,
    SearchDropDownComponent,
    SidebarComponent,
    SortIndicatorComponent,
    ToastComponent,
    TooltipComponent,

    // --- Modals ---
    GenericConfirmationModalComponent,
    GenericModalComponent,
    GenericSuccessModelComponent,
    SupportModalComponent,
    SupportTicketRequestModalComponent,
    UserProfileModalComponent,

    // --- Dialogs ---
    ActionResultDialogComponent,
    ConfirmDialogComponent,
    OrganizationDialogComponent,

    // --- Directives ---
    DialogDirective,
    PhoneDirective,
    ToasterDirective,

    // --- Pipes ---
    ArrayFilterPipe,
    FormattedTablePipe,
    LimitToPipe,
  ],
  exports: [
    // --- UI Components ---
    ActionsPopupComponent,
    AddressComponent,
    BaseLoadingComponent,
    ButtonComponent,
    CheckboxComponent,
    DialogComponent,
    DropdownComponent,
    ErrorComponent,
    ErrorPageComponent,
    HistoryComponent,
    IconComponent,
    IconLinkComponent,
    ImageComponent,
    InitialsComponent,
    LoadingComponent,
    PaginationComponent,
    ProgressIndicatorComponent,
    SearchComponent,
    SearchDropDownComponent,
    SidebarComponent,
    SortIndicatorComponent,
    ToastComponent,
    TooltipComponent,

    // --- Modals ---
    GenericConfirmationModalComponent,
    SupportModalComponent,
    UserProfileModalComponent,

    // --- Dialogs ---
    ActionResultDialogComponent,
    ConfirmDialogComponent,
    OrganizationDialogComponent,

    // --- Directives ---
    DialogDirective,
    PhoneDirective,
    ToasterDirective,

    // --- Pipes ---
    ArrayFilterPipe,
    FormattedTablePipe,
    LimitToPipe,

    // --- Tour (re-exported from ngx-ui-tour-md-menu) ---
    TourAnchorMatMenuDirective,
    TourStepTemplateComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [DialogService, DatePipe, AlertService, provideUiTour({
        asyncStepTimeout: 5000
      })],
    }
  }
}
